import { render, staticRenderFns } from "./EmployeeNocDocuments.vue?vue&type=template&id=32abc207"
import script from "./EmployeeNocDocuments.vue?vue&type=script&lang=js"
export * from "./EmployeeNocDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports